import React from "react"
import Button from "@material-ui/core/Button"
import { Link } from "react-router-dom"
import ChannelIcon from "@material-ui/icons/DonutSmall"
import MemberIcon from "@material-ui/icons/People"
export const ChannelButton = ({ record }) => (
  <Button
    variant="flat"
    component={Link}
    to={{
      pathname: `/merchants/${record.id}/channels`,
      state: { record: { merchart_id: record.id } },
    }}
  >
    <ChannelIcon color="primary" />
  </Button>
)

export const MemberButton = ({ record }) => {
  // console.log(record)
  return (
    <Button
      variant="flat"
      component={Link}
      to={{
        pathname: `/levels/${record.id}/members`,
        state: { record: { merchart_id: record.id } },
      }}
    >
      <MemberIcon color="primary" />
    </Button>
  )
}
